import { FC, useEffect } from 'react';
import { useStyles } from './styles';
import { useStore } from 'hooks/useRootStore';
import { useAppPreloader } from 'hooks/useAppPreloader';
import { useMutation } from 'react-query';
import { Grid, TextField, Button, FormControl, Paper, FormHelperText, MenuItem } from '@material-ui/core';
import { observer } from 'mobx-react-lite';
import { ReactComponent as LogoIcon } from 'assets/logo.svg';
import { useHistory } from 'react-router';
import { useForm, Controller } from 'react-hook-form';
import { handleCompanyUrl } from 'utils/organizationUtils';

const EnterDomain: FC = observer(() => {
  const classes = useStyles();
  const history = useHistory();
  const {
    userStore: { user, updateDomain, getAWSRegion, clientAWSRegionInfo },
    notificationStore: { openNotification },
  } = useStore();

  const updateDomainRequest = useMutation('updateDomainRequest', updateDomain, {
    onSuccess: (e) => {
      user?.permission !== 'EndUser'
        ? history.push(handleCompanyUrl('/dashboard'))
        : history.push(handleCompanyUrl('/reports'));
    },
    onError: ({ message }: Error) => openNotification('error', message ? message : 'Something went wrong'),
  });
  const getClientAWSRegionReq = useMutation('getClientActivationInfoReq', getAWSRegion, {
    onError: ({ message }: Error) => openNotification('error', message),
  });

  useEffect(() => {
    document.title = 'EasyIdentity: Admin Login';
    getClientAWSRegionReq.mutate.call(null, user?.id);
    // eslint-disable-next-line
  }, []);

  useAppPreloader(updateDomainRequest.isLoading || getClientAWSRegionReq.isLoading);

  const { control, handleSubmit } = useForm();
  const onSubmit = (data: any) => {
    data.id = user?.id ? user.id : null;
    data.region = data.region ? data.region : clientAWSRegionInfo?.defaultRegion;
    updateDomainRequest.mutate.call(null, data);
  };

  return (
    <Grid item className={classes.container}>
      <div className={classes.topBar}>
        <LogoIcon style={{ marginLeft: '40px', width: '140px', height: '52px' }} />
      </div>
      <Grid container className={classes.main} justify='center'>
        <Grid item lg={4}>
          {!getClientAWSRegionReq.isLoading && (
            <Paper className={classes.paper} elevation={3}>
              {/* <h1 className={classes.title}>Login</h1> */}
              <form className={classes.widthFull} onSubmit={handleSubmit(onSubmit)}>
                <Grid container justify='center'>
                  {/* <Grid className={classes.row} container>
                  <FormControl classes={{ root: classes.widthFull }}>
                    <Controller
                      name='organizationDomain'
                      render={({ field, fieldState: { invalid, error } }) => (
                        <>
                          <TextField
                            {...field}
                            color='primary'
                            id='organization-domain'
                            className={classes.widthFull}
                            defaultValue={clientAWSRegionInfo?.defaultDomain}
                            variant='outlined'
                            fullWidth
                            label='Enter Domain for your Cloud Directory'
                            placeholder='example.com'
                            autoFocus
                            error={invalid}
                          />
                          {error ? <FormHelperText error>Incorrect domain name</FormHelperText> : null}
                        </>
                      )}
                      control={control}
                      rules={{
                        required: true,
                        pattern: /^[a-zA-Z0-9][a-zA-Z0-9-]{1,61}[a-zA-Z0-9](?:\.[a-zA-Z]{2,})+$/,
                      }}
                    />
                  </FormControl>
                </Grid> */}
                  <Grid className={classes.row} container>
                    <Controller
                      name='region'
                      control={control}
                      // rules={{ required: true }}
                      render={({ field, fieldState: { invalid, error } }) => (
                        <Grid container>
                          <FormControl className={classes.input}>
                            <TextField
                              select
                              {...field}
                              id='1'
                              variant='outlined'
                              label='Select Data Hosting Region'
                              error={invalid}
                              className={classes.input}
                              defaultValue={clientAWSRegionInfo?.defaultRegion}
                            >
                              {error ? <FormHelperText error>Please Select a Region</FormHelperText> : null}
                              {clientAWSRegionInfo &&
                                clientAWSRegionInfo.EC2AWSRegion.map((_item: any) => (
                                  <MenuItem key={_item} value={_item}>
                                    {_item}
                                  </MenuItem>
                                ))}
                            </TextField>
                          </FormControl>
                        </Grid>
                      )}
                    />
                  </Grid>
                  <Grid className={classes.row} container>
                    <FormControl style={{ marginTop: 0 }} classes={{ root: classes.widthFull }}>
                      <Controller
                        name='directoryName'
                        render={({ field, fieldState: { invalid, error } }) => (
                          <>
                            <TextField
                              {...field}
                              color='primary'
                              id='directory-name'
                              // className={classes.widthFull}
                              // defaultValue={clientAWSRegionInfo?.defaultDomain}
                              variant='outlined'
                              fullWidth
                              label='Directory Name'
                              placeholder='MyCloud Directory'
                              autoFocus
                              error={invalid}
                            />
                            {error ? <FormHelperText error>Incorrect directory name</FormHelperText> : null}
                          </>
                        )}
                        control={control}
                        rules={{
                          required: true,
                          // pattern: /^[a-zA-Z0-9][a-zA-Z0-9-]{1,61}[a-zA-Z0-9](?:\.[a-zA-Z]{2,})+$/,
                        }}
                      />
                    </FormControl>
                  </Grid>
                </Grid>
                <Grid container justify='space-between' alignItems='center' className={classes.marginTop}>
                  <Button className={classes.button} type='submit' fullWidth variant='contained' color='primary'>
                    Next
                  </Button>
                </Grid>
              </form>
            </Paper>
          )}
        </Grid>
      </Grid>
      {/* <div className={classes.footer}>
        <p>Copyright 2022 9STAR, All Rights Reserved. Version 0.1.39</p>
      </div> */}
    </Grid>
  );
});

export default EnterDomain;
